(function () {
    'use strict';

    /**
     * FAQ section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_FAQ.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "faqSection"
     * and still sees the page "vm" (getStyle, showLoading).
     * Not "faq" - the markup uses faq as the ng-repeat item.
     */
    angular
        .module('EventListApp')
        .directive('wsSectionFaq', sectionFaq);

    function sectionFaq() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionFaqCtrl,
            controllerAs: 'faqSection'
        };
    }

    SectionFaqCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionFaqCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.bySubject = {};

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        vm.isRTL = function (text) {
            return isRTL(text);
        };

        /**
         * Load the FAQ list of the event, grouped by subject
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise}
         */
        function load(eventId, lang) {
            return ApiFactory.GetFAQ(eventId, lang).then(function (response) {
                vm.bySubject = groupBySubject(response.data || []);
            });
        }

        function groupBySubject(list) {
            const groups = {};
            list.forEach(function (faq) {
                const key = faq.subject || '';
                if (!groups[key])
                    groups[key] = [];

                groups[key].push(faq);
            });

            return groups;
        }
    }
})();
